import { observer } from "mobx-react-lite";

import { useNodeStyle } from "@/components/expression/utils/NodeStyleProvider";
import { Icon, type IconName } from "@/components/icons/Icon";
import { twMerge } from "@/utils/twMerge";

type Props = {
  filled?: boolean;
  index?: string;
};

export const Placeholder = observer(function Placeholder({ filled, index }: Props) {
  const { size, view } = useNodeStyle();

  let iconName: IconName = filled ? "PlaceholderFilled" : "Placeholder";

  if (index) {
    iconName = "PlaceholderWithIndex";
  }

  return (
    <div
      className={twMerge(
        "flex flex-1 flex-nowrap justify-center relative hoverable-icon-secondary",
        size === "sm" && "w-[21px] h-[21px]",
        size === "xs" && "w-4 h-4",
        size === "xxs" && "w-3.5 h-3.5",
      )}
    >
      <Icon
        name={iconName}
        className={twMerge(
          "absolute left-0 top-0 w-full h-full pointer-events-none",
          size === "xs" && "stroke-[0.08rem]",
          size === "xxs" && "stroke-[0.09rem]",
        )}
      />
      {index && (
        <div
          className={twMerge(
            "select-none text-xxxs text-gray-500 absolute bottom-0 right-0.5",

            view === "expression" && size === "xxs" && "right-0",
          )}
        >
          {index}
        </div>
      )}
    </div>
  );
});
